import gql from "graphql-tag";

// noinspection GraphQLUnresolvedReference
export const compositionReportNoDepartmentQuery = gql`
    query compositionReportNoDepartment($retailerId:Int!, $salesEndDate: String){
        records:compositionReportNoDepartment(retailerId: $retailerId, salesEndDate: $salesEndDate){
            retailerId
            spinsItemCode
            salesAmountTotal
            salesUnitTotal
            itemDescription
        }
    }`;


// noinspection GraphQLUnresolvedReference
export const compositionReportCodeAbleItemsQuery = gql`
    query compositionReportCodeAbleItems($retailerId:Int!, $salesEndDate: String){
        records:compositionReportCodeAbleItems(retailerId: $retailerId, salesEndDate: $salesEndDate){
            retailerId
            spinsItemCode
            salesAmountTotal
            salesUnitTotal
            itemDescription
        }
    }`;